"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bnb_javascript_sdk_nobroadcast_1 = require("bnb-javascript-sdk-nobroadcast");
const core_1 = require("../core");
exports.default = {
    create(keyPair) {
        return __awaiter(this, void 0, void 0, function* () {
            return (tx, signMsg) => __awaiter(this, void 0, void 0, function* () {
                const signBytes = tx.getSignBytes(signMsg);
                const pubKey = bnb_javascript_sdk_nobroadcast_1.crypto.getPublicKey(Buffer.from(yield keyPair.getPublicKey()).toString("hex"));
                const sig = Buffer.from(yield core_1.SecP256K1.Signature.signCanonically(keyPair, "sha256", signBytes));
                tx.addSignature(pubKey, sig);
                return tx;
            });
        });
    }
};
